"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    paddingY: 6,
    paddingX: {
        base: 6,
        md: 4,
    },
    borderRadius: 'sm',
    background: 'white',
    shadow: 'sm',
};
const CardStyle = {
    baseStyle,
};
exports.default = CardStyle;
